import { getCurrentInstance, onUnmounted, Ref, ref } from 'vue'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'
import { TailwindConfig } from 'tailwindcss/tailwind-config'
import { debounce } from '@/utils/debounce'

const fullConfig = resolveConfig(tailwindConfig as TailwindConfig)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const mdConfig = fullConfig.theme.screens!.md
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const lgConfig = fullConfig.theme.screens!.lg

const mdWidth = parseInt(mdConfig.slice(0, mdConfig.indexOf('px')), 10)
const lgWidth = parseInt(lgConfig.slice(0, lgConfig.indexOf('px')), 10)

export default function useScreen (): { isSmScreen: Ref<boolean>, isMdScreen: Ref<boolean> } {
  const isSmScreen = ref(false)
  const isMdScreen = ref(false)
  const updateScreenSizes = debounce(() => {
    isSmScreen.value = window.innerWidth < mdWidth
    isMdScreen.value = window.innerWidth < lgWidth
  }, 100)

  updateScreenSizes()
  window.addEventListener('resize', updateScreenSizes)

  if (getCurrentInstance()) {
    onUnmounted(() => {
      window.removeEventListener('resize', updateScreenSizes)
    })
  }

  return { isSmScreen: isSmScreen, isMdScreen: isMdScreen }
}
